<template>
  <div class="about">
    <PhotoWall :imgUrls="coverImgUrls" :autoDisplay="false" coverLetter=":About"></PhotoWall>
  </div>
</template>

<script>
// @ is an alias to /src
import PhotoWall from "@/components/PhotoWall.vue";

export default {
  name: "home",
  components: {
    PhotoWall
  },
  data() {
    return {
      coverImgUrls: [
        "https://images.unsplash.com/photo-1526880792616-4217886b9dc2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.about {
  width: 100%;
}
</style>
